export const DISCOVER_TAB = 'discover'
export const MANAGE_TAB = 'manage'
export const TABS = [DISCOVER_TAB, MANAGE_TAB]
export const TAB_DFLT = DISCOVER_TAB
